<template>
  <div>
    <div class="col bg-fade-primary-dark-8 p-5">
      <div class="d-flex align-items-center row h-100 m-0">
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Sunrise
          </p>
          <p class="display-3 align-middle">
            {{ info.sunrise }}
          </p>
        </div>
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Moonrise
          </p>
          <p class="display-3 align-middle">
            {{ info.moonrise }}
          </p>
        </div>
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Sunset
          </p>
          <p class="display-3 align-middle">
            {{ info.sunset }}
          </p>
        </div>
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Moonset
          </p>
          <p class="display-3 align-middle">
            {{ info.moonset }}
          </p>
        </div>
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Earth to Moon
          </p>
          <p class="display-3 align-middle">
            {{ info.moon_distance }}
          </p>
        </div>
        <div class="col-6">
          <p class="display-2 text-secondary align-middle">
            Moon Phase
          </p>
          <p class="display-3 align-middle">
            {{ emoji }} {{ phase }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Moon } from 'lunarphase-js';

export default {
  name: 'Almanac',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      phase: Moon.lunarPhase(),
      emoji: Moon.lunarPhaseEmoji(),
    };
  },
};
</script>
